
import { finalize, retryWhen, tap, delayWhen, take, takeUntil } from 'rxjs/operators';
import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, DoCheck, Renderer2, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { SignInRequestStoda } from '@otas/model/sign-in-request';
import { LoginStodaService } from './login-stoda.service';
import { Router } from '@angular/router';
// import 'rxjs/add/operator/finally';
import * as _ from 'underscore';
import { ToasterService } from '../services/toaster.service';
import { IpcUtilService } from '@otas/utils/directives/helper/ipc-util.service';
import { TranslateService } from '../../translate/translate.service';
import { CurrentUser } from '@otas/model/current-user';
import { PrinterSettingsService } from '@otas/stoda-settings/stoda-settings/printer-settings/printer-settings.service';
import { AppConstants } from '../app.constants';
import { PanchangService } from '@otas/utils/custom-components/panchang-calendar/panchang.service';
import { timer } from 'rxjs';
import { ProgressBarService } from '@otas/shared/progress-bar/progress-bar.service';
import { environment } from 'environments/environment';
import { GlobalUtilService } from '@otas/core/services/global-util.service';
import { GlobalData } from 'app/globalData';
import { TempleService } from '../shivam/temple/temple.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyModalComponent } from '../shivam/privacy-modal/privacy-modal.component';
import { HostListener } from '@angular/core';
import { ModuleVersionService } from '../services/module-version.service';
import { WithoutInterceptor } from '../services/without.interceptor';
import { AccountCorrectionCheckService } from '../modules-v2/accounting/state/account-correction-check.service';
import {
  ServerStatusState, SERVER_RETRY_MS, isLocalApiUrl, nextServerStatus,
  serverStatusMessage, shouldRequestServerStart
} from './server-status';
// declare var window: any;

@Component({
  selector: 'app-login-stoda',
  templateUrl: './login-stoda.component.html',
  styleUrls: ['./login-stoda.component.css'],
  providers: [LoginStodaService, PrinterSettingsService],
  standalone: false
})
export class LoginStodaComponent implements OnInit, AfterViewInit, OnDestroy {
  url: any;
  homeUrl: any;
  temples: any[] = [];
  selectedTempleCode: string = '';
  panchangCalenderOpts = { keyboardNavigation: false, startDate: new Date() };

  userData: any;
  userForm: UntypedFormGroup;
  signUpForm: UntypedFormGroup;
  submitted = false;
  loading = false;
  show = false;
  data: any = [] = [];
  slider = false;
  confirmPassword: any;
  string: string;
  roles: any[] = [];
  alreadySignIn = false;
  isPassword = true;
  templeOwnerSignUpForm: UntypedFormGroup;
  isValidUser = true;
  language = 'english';
  // language = 'malayalam';
  ip;
  submitteing = false;

  templeOwnerFlag = false;
  currentUser: CurrentUser;
  isLocalServer = false;
  get showTempleDropdown(): boolean {
    return !this.isLocalServer && this.temples.length > 1;
  }
  pdfUrl: any;
  isMobile = false;
  /**
   * R48 login server-status panel (rendered above the LOG IN block). The
   * electron-era flow - probe the API, start the local server, show a circle
   * while waiting - is an explicit 10s loop now; see server-status.ts.
   */
  serverStatus: ServerStatusState = 'checking';
  serverStatusMessage = serverStatusMessage('checking');
  private statusTimer: any = null;
  private outageStartedAt = 0;
  private lastServerInitAt: number | null = null;
  private destroyed = false;
  // bgColor = '#977947';
  constructor(private fb: UntypedFormBuilder, private ipcutil: IpcUtilService, private translate: TranslateService,
    private printerSettingsService: PrinterSettingsService, private panchangService: PanchangService,
    private globalUtilService: GlobalUtilService, private renderer: Renderer2,
    private progressBarService: ProgressBarService, private elementRef: ElementRef,
    private loginStodaService: LoginStodaService, private router: Router, public toastr: ToasterService,
    private templeService: TempleService, private modalService: NgbModal,
    private moduleVersionService: ModuleVersionService, private pingClient: WithoutInterceptor,
    private accountCorrectionCheck: AccountCorrectionCheckService,
    private cdr: ChangeDetectorRef) {
    // try {
    //   // this.getBgColor();
    //   // this.renderer.setStyle(this.elementRef.nativeElement,"background-color",this.bgColor);
    //   const fs = this.globalUtilService.fsInstance;
    //   if (fs) {
    //     const language = '' + fs.readFileSync(this.globalUtilService.configPath + '/app.lang');
    //     this.language = (!!language) ? language : this.language;
    //   }
    // } catch (e) {
    //   this.language = this.language;
    // }
    console.log('sessionStorage.getItem(language) >> ', sessionStorage.getItem('language'));
    // const _lang = sessionStorage.getItem('language');
    // this.language = _lang === null ? globalUtilService.language : _lang; // Ajesh commented above 21-10-2021
    this.language = this.globalUtilService.isTauriApp ? this.globalUtilService.language : 'english';
    // this.language = 'malayalam';
    this.userForm = fb.group(new SignInRequestStoda());
    this.signUpForm = fb.group({ userName: [''], email: [''], password: [''], phoneNo: [''], });
  }
  // getBgColor() {
  //   if (this.globalUtilService.process) {
  //     let loc = this.globalUtilService.configPath + '/app.color';
  //     const fs = this.globalUtilService.fsInstance;
  //     if (!!fs && fs.existsSync(loc)) {
  //       const path = fs.readFileSync(loc);
  //       this.bgColor = (!!path) ? path : '#977947';
  //     } else {
  //       this.bgColor = '#977947';
  //     }
  //   }
  // }
  repStrByidx(index: number, value: string, replacement: string) {
    return value.substr(0, index) + replacement + value.substr(index + replacement.length);
  }
  async ngOnInit() {
    // Warm the lazily-loaded panchang table while the operator logs in, so the
    // booking screen has it ready; the web portal never triggers this.
    this.panchangService.ensureLoaded();
    this.onResize();
    if (document.body.classList.contains('modal-open')) {
      this.renderer.removeAttribute(document.body, 'class')
      this.renderer.removeChild(document.body, document.body.querySelector('ngb-modal-backdrop'))
      this.renderer.removeChild(document.body, document.body.querySelector('ngb-modal-window'))
    }
    this.userForm.valueChanges.pipe(take(1)).subscribe(() => {
      this.toastr.close();
    })

    sessionStorage.setItem('language', this.language);
    sessionStorage.setItem('CURRENT_USER', JSON.stringify({ typingLanguage: 'MANGLISH' }))
    // try {
    //   const fs = this.globalUtilService.fsInstance;
    //   if (fs) {
    //     this.url = fs.readFileSync(this.globalUtilService.rootPath + '/login.png');
    //     this.url = 'data:image/jpeg;base64,' + Buffer.from(this.url).toString('base64');
    //   }
    // } catch (err) {
    //   this.url = 'assets/img/login-logo.png';
    // }
    this.url = this.globalUtilService.isTauriApp ? this.globalUtilService.loginImage : null; // Ajesh commented above 21-10-2021
    if (this.globalUtilService.isTauriApp) {
      try {
        const api = this.globalUtilService.API;
        const port = this.globalUtilService.PORT;

        if (api) {
          this.isLocalServer = true;
          // Update environment URL for local server mode
          const baseUrl = `http://${api}:${port}`;
          environment.apiUrl = baseUrl + '/';
          environment.authTokenEndpoint = `${baseUrl}/oauth/token`;
          environment.userinfoEndpoint = `${baseUrl}/user`;
          console.log("Local Server Mode: API URL updated to", environment.apiUrl);
        } else {
          this.isLocalServer = false;
          console.log("Cloud Mode: Using default API URL", environment.apiUrl);
        }

        // Apply branding background color
        const bg = this.globalUtilService.bgColor;
        if (bg) {
          document.body.style.backgroundColor = bg;
        }

        const deps: any = await this.globalUtilService.checkSystemDependencies();
        // runtime_valid means java.exe exists AND java -version works
        const needsRuntime = !deps.runtime_valid;
        // mysql_service_up means MySQL service is registered in Windows services
        const needsEngine = !deps.mysql_service_up && deps.is_server;

        if (needsRuntime || needsEngine) {
          this.router.navigate(['/setup-wizard'], { queryParams: { needsRuntime, needsEngine } });
          return;
        }
      } catch (e) {
        console.error("Dependency check failed:", e);
      }
    }
    // R48: explicit server-status loop (replaces the electron-era retryWhen
    // machinery, which the Tauri migration had silently disabled). Probes the
    // API every SERVER_RETRY_MS through WithoutInterceptor - no global toast/
    // loader noise per attempt - and renders its state above the LOG IN block.
    this.runServerCheck();
  }

  /** One reachability probe; reschedules itself until the server answers. */
  private runServerCheck() {
    if (this.destroyed) { return; }
    // `all` is permitAll and doubles as the tenant feed - the same probe the
    // electron app used. WithoutInterceptor bypasses the api-url rewrite, so
    // the URL must be absolute (environment.apiUrl was resolved from
    // serve.path just above for the local-server mode).
    // R51: the probe's 200 body IS the full tenant feed — hand it to
    // onServerUp so the tenant resolution reuses it instead of downloading
    // the same payload a second time (the duplicate `all` the owner saw).
    this.pingClient.get(environment.apiUrl + 'temple/all').subscribe({
      next: (feed) => this.onServerUp(feed),
      error: () => this.onServerDown()
    });
  }

  private onServerDown() {
    if (this.destroyed) { return; }
    if (!this.outageStartedAt) { this.outageStartedAt = Date.now(); }
    const isLocal = isLocalApiUrl(environment.apiUrl);
    this.serverStatus = nextServerStatus(isLocal, Date.now() - this.outageStartedAt);
    this.serverStatusMessage = serverStatusMessage(this.serverStatus);
    // Local server not answering: ask the shell to start it (stoda.vbs starts
    // the MySQL + STODA services, electron parity). R48b: re-requested every
    // LOCAL_REINIT_MS while the outage lasts - a silently-failed first
    // attempt (dismissed UAC, crashed starter) no longer strands the page on
    // "starting" forever. Safe to repeat: the Rust arm checks `sc query` and
    // only issues a start when the STODA service is actually STOPPED, so a
    // slow-but-healthy START_PENDING service is never poked twice.
    if (this.globalUtilService.isTauriApp
      && shouldRequestServerStart(isLocal, this.lastServerInitAt, Date.now())) {
      this.lastServerInitAt = Date.now();
      this.globalUtilService.IPCRendererSend('serverInitialize');
    }
    this.cdr.markForCheck();
    this.statusTimer = setTimeout(() => this.runServerCheck(), SERVER_RETRY_MS);
  }

  private onServerUp(feed?: any) {
    if (this.destroyed) { return; }
    this.outageStartedAt = 0;
    this.lastServerInitAt = null;
    // R48b owner feedback: no "Server up Now" toast - the glowing green
    // "Server online" indicator is the intimation.
    this.serverStatus = 'up';
    this.serverStatusMessage = serverStatusMessage('up');
    this.cdr.markForCheck();
    // Server reachable: resolve the tenant. R51: the probe response already
    // carries the whole `all` payload, so on the desktop flow resolveTenant
    // applies it directly - ONE `all` request per login-page arrival instead
    // of two identical ones (probe + getVersionCheck).
    this.loginStodaService.resolveTenant(feed).pipe(finalize(() => { this.loading = false; }))
      .subscribe((data: any) => {
        // WS-DBM Phase 3: an empty database has no temple to log in against — send
        // the operator to the one-time registration screen instead of a dead login.
        if (this.loginStodaService.unregistered) {
          this.router.navigate(['/temple-registration']);
          return;
        }
        console.log("temple", localStorage.getItem('temple'), data);
        const templeData = localStorage.getItem('temple') ? JSON.parse(localStorage.getItem('temple')) : [];
        if (templeData && templeData.length > 0) {
          this.temples = templeData;
          if (this.temples.length === 1) {
            this.selectedTempleCode = this.temples[0].id;
            // localStorage.setItem('tuid', this.temples[0].tuid);
            localStorage.setItem('homeUrl', this.temples[0].homeUrl);
          } else {
            // localStorage.removeItem('tuid');
            localStorage.removeItem('homeUrl');
          }
        }
        this.cdr.markForCheck();
      }, () => {
      });
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.statusTimer) {
      clearTimeout(this.statusTimer);
      this.statusTimer = null;
    }
  }

  onTempleChange() {
    if (this.selectedTempleCode) {
      const selectedT = this.temples.find(t => t.tuid === this.selectedTempleCode);
      if (selectedT) {
        localStorage.setItem('tuid', selectedT.tuid);
        localStorage.setItem('homeUrl', selectedT.homeUrl);
      }
    } else {
      localStorage.removeItem('tuid');
      localStorage.removeItem('homeUrl');
    }
  }

  // ngDoCheck() {

  // }

  // ngOnDestroy(): void {
  //   console.log('on destroying login....',this.loading);
  //   this.loading = false;
  // }

  ngAfterViewInit() {
    if (this.globalUtilService.isTauriApp) {
      this.globalUtilService.IPCRendererSend('machine-id');
      this.globalUtilService.IPCRendererOn('machine-id-data', ((event, data) => {
        this.ip = data;
      }).bind(this));
    }
    // this.ip = this.electronService.process.env.ip;
    // getUserIP((ip) => { this.ip = ip; });
  }

  async chooseLang(value) {
    sessionStorage.setItem('language', this.language);
    this.translate.setDefaultLang(this.language === 'malayalam' ? 'ml' : (this.language === 'tamil' ? 'ta' : (this.language === 'kannada' ? 'kn' : 'en')));
    this.translate.enableFallback(true);
    this.translate.use(this.language === 'malayalam' ? 'ml' : (this.language === 'tamil' ? 'ta' : (this.language === 'kannada' ? 'kn' : 'en')));
    this.translate.enableFallback(true);
    if (this.globalUtilService.isTauriApp) {
      this.globalUtilService.language = this.language;
    }
    sessionStorage.setItem('CURRENT_USER', JSON.stringify({ typingLanguage: 'MANGLISH' }))
  }

  toggleShow() {
    this.isPassword = !this.isPassword;
  }
  passwordKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 13 && this.userForm.controls.userName.value) {

      event.preventDefault();
      this.login();
    }

  }
  delete(event) {

  }
  selectFile(event) {

  }
  login() {
    if (this.userForm.invalid) {
      this.submitted = true;
      return;
    }

    if (this.showTempleDropdown && !this.selectedTempleCode) {
      this.toastr.showAlways({
        type: 'warning', position: 'topCenter', icon: 'material-icons warning',
        title: 'Warning', message: 'Please select a Temple to log in.'
      });
      return;
    }

    this.loading = true; //ajesh
    const request: SignInRequestStoda = this.userForm.value;
    request.ip = this.ip ? this.ip : null;
    request.tuid = this.temples.length > 1 ? this.selectedTempleCode : null;
    if (this.language === 'malayalam') {
      request.language = 'ml';
    }
    if (this.language === 'tamil') {
      request.language = 'ta';
    }
    if (this.language === 'kannada') {
      request.language = 'kn';
    }
    if (this.language === 'english') {
      request.language = 'en';
    }
    if (this.globalUtilService.isTauriApp)
      this.globalUtilService.IPCRendererSend('language', this.language === 'malayalam' ? 'ml' : (this.language === 'tamil' ? 'ta' : (this.language === 'kannada' ? 'kn' : 'en')));
    this.loginStodaService.login(request).pipe(finalize(() => { this.loading = false; }), retryWhen((error) => {

      return error.pipe(takeUntil(timer(4 * 60 * 1000)), tap(val => val),
        //restart in 4 minutes

        delayWhen(val => timer(20 * 1000)))
    }
    )).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.currentUser = res.result;
        sessionStorage.setItem('CURRENT_USER', JSON.stringify(this.currentUser));
        sessionStorage.setItem('language', this.language);
        if (this.globalUtilService.isTauriApp)
          this.ipcutil.keyboardType = this.ipcutil.getKeyBoardType();

        if (this.currentUser.expireDays <= 30) {
          if (this.currentUser.expireDays <= 0) {
            this.toastr.error('Software license has expired on ' + this.currentUser.expireOn
              + '. You can upgrade or renew it.', 'ERROR', '1', 20000 * 10);
          } else {
            this.toastr.warning('Your Software license is up to ' + this.currentUser.expireDays + ' days', 'WARNING', '1', 20000 * 10);
          }
        }
        if (this.currentUser.isFirstLogin) {
          this.printerSettingsService.getPrintConfigs().subscribe((resp) => {
            const printerConfigs = resp.result.printerConfig;
            this.printerSettingsService.saveToConfigFile(printerConfigs);

          });
        } else {
          this.printerSettingsService.readConfigFile().then(r => {
            // (this.currentUser as any).dpi = r.split('temple.dpi=')[1]?.replace(/[\r\n]+/g, '');
            // (this.currentUser as any).dimension = r.split('pooja.dimension=')[1]?.replace(/[\r\n]+/g, '');
            (this.currentUser as any).dpi = r.split('temple.dpi=')[1]?.split('\n')[0];
            (this.currentUser as any).paper = r.split('pooja.paper=')[1]?.split('\n')[0];
            sessionStorage.setItem('CURRENT_USER', JSON.stringify(this.currentUser));

          }).catch(r => { });

        }
        if (!!this.currentUser.dateFormat) {
          AppConstants.displayDateFormat = this.currentUser.dateFormat;
          AppConstants.newDateFormat = this.currentUser.dateFormat;
        }

        if (this.globalUtilService.isTauriApp && !!this.currentUser.templeLogo) {
          this.globalUtilService.IPCRendererSend('setLogo', this.globalUtilService.configPath, this.currentUser.templeLogo);
        }


        this.alreadySignIn = true;
        this.submitted = false;
        this.userForm.reset();
        // this.router.navigate(['app/reports/pooja-report']);
        // this.router.navigate(['app/reports/expense']);
        this.loginStodaService.getPoojas();
        // this.loginStodaService.getMaterials();
        this.setGlobalApi();
        if (this.currentUser) {
          const roles = [];
          _.map(this.currentUser.roles, role => {
            roles.push(role.name);
            return role;
          });
          const goHome = () => {
            if (_.contains(roles, 'POOJA_BILLING_ACCESS') || _.contains(roles, 'POOJA_FULL_ACCESS') || _.contains(roles, 'TEMPLE_ADMIN') || _.contains(roles, 'FULL_ACCESS') || _.contains(roles, 'COMPANY_ACCESS')) {
              this.loading = false;
              // console.log('destroying login....',this.loading);
              // Workstream E phase 2: the default booking screen follows the
              // per-temple VAZHIPADU module version (V2 default = pooja-v2).
              // refresh() forces a fetch per login (a re-login in the same
              // window may target another temple) and never errors, so
              // navigation always happens.
              this.moduleVersionService.refresh().subscribe(() => {
                this.router.navigate([this.moduleVersionService.bookingRoute()]);
              });

            } else {
              this.loading = false;
              this.router.navigate(['app/dashboard']);
            }
          };
          // R74e: a migrated database flagged NEEDS_ACCOUNT_CORRECTION sends
          // correction-capable users straight to the Account Corrections
          // wizard. get() reads ONE cached config row on the server (the
          // detection sweep ran once at first boot), so this costs nothing
          // per login; any error or a clean flag falls through to goHome().
          const canCorrect = AccountCorrectionCheckService.CORRECTION_ROLES
            .some(r => _.contains(roles, r));
          if (canCorrect) {
            this.accountCorrectionCheck.get().subscribe({
              next: (res: any) => {
                if (res?.result?.needed) {
                  this.loading = false;
                  this.toastr.warning('This database still needs one-time account corrections '
                    + '— opening the Account Corrections wizard.', 'ACCOUNT CORRECTIONS', '1', 12000);
                  this.router.navigate(['app/accounting-v2/coa-merge']);
                } else {
                  goHome();
                }
              },
              error: () => goHome(), // older backend / offline — never block login
            });
          } else {
            goHome();
          }
        }
      }
    }, error => {

    });
  }
  // setBank() {
  //   this.loginStodaService.getAllbankList().subscribe(response => {
  //     if (!!response.result && response.result.length > 0) {
  //       GlobalData.menus[0].array.push(response.result);
  //     }
  //   });
  // }
  setGlobalApi() {
    _.find(GlobalData.menus, (menu, index) => {
      this.loginStodaService.getApi(menu.api).subscribe(response => {
        if (!!response.result && response.result.length > 0) {
          GlobalData.menus[index].array.push(response.result);
        }
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.isMobile = window.innerWidth <= 768;
  }

  privacy() {
    this.modalService.open(PrivacyModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true
    });
  }
}
